import React, { useContext } from 'react';
import { Menu, MenuItem, Box, Typography, Avatar, Divider, ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthContext } from '../../contexts/AuthContext';

const ProfileMenu = ({ anchorEl, open, onClose }) => {
    const navigate = useNavigate();
    const { logout, auth } = useContext(AuthContext);

    // Mock user data if auth.user is just an email or ID
    // Ideally, auth.user should be an object with these fields, or we fetch them.
    // For now, we'll use what we have or placeholders.
    const user = {
        name: auth.user?.name || "Usuário",
        username: auth.user?.email || "@usuario",
        photo: auth.user?.photo_url || "",
        role: auth.roleId === 1 ? "Admin" : auth.roleId === 3 ? "Gerente" : "Colaborador",
        store: localStorage.getItem("vochica_store") || "Loja"
    };

    const handleLogout = () => {
        logout();
        onClose();
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    minWidth: 200,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <Box sx={{ px: 2, py: 1 }}>
                <Typography variant="subtitle1" noWrap>
                    {user.name}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                    {user.username}
                </Typography>
                <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'primary.main' }}>
                    {user.role} • {user.store}
                </Typography>
            </Box>
            <Divider />
            <MenuItem onClick={() => { navigate('/profile'); onClose(); }}>
                <ListItemIcon>
                    <PersonIcon fontSize="small" />
                </ListItemIcon>
                Meu Perfil
            </MenuItem>
            <MenuItem onClick={() => { navigate('/profile'); onClose(); }}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                Editar Perfil
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Sair
            </MenuItem>
        </Menu>
    );
};

export default ProfileMenu;
